
// Daypart data organized by segment
export const daypartDataBySegment = {
  urban: [
    { hour: '5-6 AM', residential: 12, commercial: 8, commuters: 30 },
    { hour: '6-7 AM', residential: 18, commercial: 16, commuters: 45 },
    { hour: '7-8 AM', residential: 22, commercial: 28, commuters: 65 },
    { hour: '8-9 AM', residential: 24, commercial: 35, commuters: 55 },
    { hour: '9-10 AM', residential: 20, commercial: 42, commuters: 30 },
    { hour: '10-11 AM', residential: 18, commercial: 38, commuters: 20 },
    { hour: '11-12 PM', residential: 22, commercial: 45, commuters: 18 },
    { hour: '12-1 PM', residential: 30, commercial: 52, commuters: 22 },
    { hour: '1-2 PM', residential: 25, commercial: 48, commuters: 20 },
    { hour: '2-3 PM', residential: 22, commercial: 40, commuters: 25 },
    { hour: '3-4 PM', residential: 20, commercial: 38, commuters: 35 },
    { hour: '4-5 PM', residential: 25, commercial: 36, commuters: 42 },
    { hour: '5-6 PM', residential: 32, commercial: 34, commuters: 58 },
    { hour: '6-7 PM', residential: 35, commercial: 28, commuters: 48 },
    { hour: '7-8 PM', residential: 30, commercial: 22, commuters: 32 },
    { hour: '8-9 PM', residential: 25, commercial: 16, commuters: 22 },
    { hour: '9-10 PM', residential: 18, commercial: 12, commuters: 15 },
    { hour: '10-11 PM', residential: 12, commercial: 8, commuters: 10 }
  ],
  highway: [
    { hour: '5-6 AM', residential: 8, commercial: 18, commuters: 12 },
    { hour: '6-7 AM', residential: 10, commercial: 25, commuters: 15 },
    { hour: '7-8 AM', residential: 12, commercial: 35, commuters: 22 },
    { hour: '8-9 AM', residential: 15, commercial: 45, commuters: 28 },
    { hour: '9-10 AM', residential: 16, commercial: 55, commuters: 32 },
    { hour: '10-11 AM', residential: 18, commercial: 62, commuters: 35 },
    { hour: '11-12 PM', residential: 22, commercial: 68, commuters: 32 },
    { hour: '12-1 PM', residential: 25, commercial: 72, commuters: 35 },
    { hour: '1-2 PM', residential: 22, commercial: 70, commuters: 38 },
    { hour: '2-3 PM', residential: 20, commercial: 65, commuters: 35 },
    { hour: '3-4 PM', residential: 18, commercial: 58, commuters: 32 },
    { hour: '4-5 PM', residential: 20, commercial: 52, commuters: 30 },
    { hour: '5-6 PM', residential: 22, commercial: 48, commuters: 32 },
    { hour: '6-7 PM', residential: 25, commercial: 42, commuters: 28 },
    { hour: '7-8 PM', residential: 20, commercial: 35, commuters: 25 },
    { hour: '8-9 PM', residential: 15, commercial: 28, commuters: 22 },
    { hour: '9-10 PM', residential: 12, commercial: 22, commuters: 18 },
    { hour: '10-11 PM', residential: 10, commercial: 15, commuters: 12 }
  ],
  rural: [
    { hour: '5-6 AM', residential: 25, commercial: 15, commuters: 5 },
    { hour: '6-7 AM', residential: 32, commercial: 22, commuters: 8 },
    { hour: '7-8 AM', residential: 28, commercial: 26, commuters: 12 },
    { hour: '8-9 AM', residential: 24, commercial: 28, commuters: 14 },
    { hour: '9-10 AM', residential: 22, commercial: 30, commuters: 12 },
    { hour: '10-11 AM', residential: 25, commercial: 28, commuters: 10 },
    { hour: '11-12 PM', residential: 30, commercial: 25, commuters: 12 },
    { hour: '12-1 PM', residential: 35, commercial: 26, commuters: 15 },
    { hour: '1-2 PM', residential: 32, commercial: 28, commuters: 12 },
    { hour: '2-3 PM', residential: 30, commercial: 32, commuters: 10 },
    { hour: '3-4 PM', residential: 32, commercial: 30, commuters: 12 },
    { hour: '4-5 PM', residential: 38, commercial: 28, commuters: 18 },
    { hour: '5-6 PM', residential: 45, commercial: 25, commuters: 22 },
    { hour: '6-7 PM', residential: 42, commercial: 22, commuters: 18 },
    { hour: '7-8 PM', residential: 35, commercial: 18, commuters: 15 },
    { hour: '8-9 PM', residential: 28, commercial: 12, commuters: 10 },
    { hour: '9-10 PM', residential: 22, commercial: 8, commuters: 6 },
    { hour: '10-11 PM', residential: 15, commercial: 6, commuters: 4 }
  ],
  suburban: [
    { hour: '5-6 AM', residential: 18, commercial: 10, commuters: 15 },
    { hour: '6-7 AM', residential: 25, commercial: 15, commuters: 28 },
    { hour: '7-8 AM', residential: 38, commercial: 22, commuters: 42 },
    { hour: '8-9 AM', residential: 35, commercial: 28, commuters: 38 },
    { hour: '9-10 AM', residential: 28, commercial: 32, commuters: 25 },
    { hour: '10-11 AM', residential: 32, commercial: 30, commuters: 18 },
    { hour: '11-12 PM', residential: 35, commercial: 32, commuters: 20 },
    { hour: '12-1 PM', residential: 38, commercial: 35, commuters: 22 },
    { hour: '1-2 PM', residential: 35, commercial: 32, commuters: 20 },
    { hour: '2-3 PM', residential: 32, commercial: 30, commuters: 22 },
    { hour: '3-4 PM', residential: 30, commercial: 28, commuters: 28 },
    { hour: '4-5 PM', residential: 35, commercial: 30, commuters: 35 },
    { hour: '5-6 PM', residential: 42, commercial: 28, commuters: 45 },
    { hour: '6-7 PM', residential: 38, commercial: 25, commuters: 35 },
    { hour: '7-8 PM', residential: 32, commercial: 20, commuters: 28 },
    { hour: '8-9 PM', residential: 28, commercial: 15, commuters: 20 },
    { hour: '9-10 PM', residential: 22, commercial: 12, commuters: 15 },
    { hour: '10-11 PM', residential: 15, commercial: 8, commuters: 10 }
  ]
};

export const segmentColors = {
  urban: {
    residential: '#4CAF50',
    commercial: '#2196F3',
    commuters: '#FF9800'
  },
  highway: {
    residential: '#4CAF50',
    commercial: '#673AB7',
    commuters: '#FFC107'
  },
  rural: {
    residential: '#4CAF50',
    commercial: '#FF5722',
    commuters: '#9C27B0'
  },
  suburban: {
    residential: '#4CAF50',
    commercial: '#2196F3',
    commuters: '#FF9800'
  }
};

export const daypartOpportunities = {
  urban: [
    {
      title: "Morning Rush (6-9 AM)",
      description: "Target commuters with grab-and-go breakfast offerings and premium coffee promotions",
      icon: "coffee"
    },
    {
      title: "Lunch Hour (12-2 PM)",
      description: "Focus on quick service food and café promotions to nearby office workers",
      icon: "utensils"
    },
    {
      title: "Evening Commute (4-7 PM)",
      description: "Promote premium fuel and loyalty program to capture returning commuters",
      icon: "car"
    }
  ],
  highway: [
    {
      title: "Mid-Morning (9 AM-12 PM)",
      description: "Target commercial drivers with fleet card promotions and food service",
      icon: "truck"
    },
    {
      title: "Afternoon (1-4 PM)",
      description: "Focus on travel-related items and refreshment offerings for long-distance travelers",
      icon: "route"
    },
    {
      title: "Late Evening (8-11 PM)",
      description: "Enhance safety features and well-lit facilities to attract night travelers",
      icon: "moon"
    }
  ],
  rural: [
    {
      title: "Early Morning (5-8 AM)",
      description: "Focus on agricultural customers with specialized offerings and early opening hours",
      icon: "tractor"
    },
    {
      title: "Mid-Afternoon (2-5 PM)",
      description: "Target local residents with community-focused promotions and everyday essentials",
      icon: "home"
    },
    {
      title: "Early Evening (5-8 PM)",
      description: "Emphasize convenience store offerings for dinner solutions and household needs",
      icon: "shopping-basket"
    }
  ],
  suburban: [
    {
      title: "School Dropoff (7-9 AM)",
      description: "Target parents with convenient breakfast and coffee options during the morning rush",
      icon: "school"
    },
    {
      title: "Weekend Midday (10 AM-2 PM)",
      description: "Focus on family-friendly offerings and car care services when families are running errands",
      icon: "shopping-cart"
    },
    {
      title: "After Work (5-7 PM)",
      description: "Promote convenience store offerings for quick dinner solutions and last-minute household needs",
      icon: "home"
    }
  ]
};

export const daypartInsights = {
  urban: "Highest value customers visit during morning rush and evening commute times. Consider targeted loyalty offers during these periods.",
  highway: "Commercial customers provide the highest volume during midday hours. Consider bulk purchase incentives for this segment.",
  rural: "Local residential customers provide consistent daily traffic. Consider community engagement strategies to strengthen loyalty.",
  suburban: "Weekend traffic is particularly valuable. Consider weekend-specific promotions to drive incremental visits."
};
